import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=c638a5ae&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=ts"
export * from "./LeftMenu.vue?vue&type=script&lang=ts"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=c638a5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c638a5ae",
  null
  
)

export default component.exports